module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_2.fc24d365.pdf";